import { Component, OnInit } from '@angular/core';
import {Router, ActivatedRoute, Params} from '@angular/router';
import {Location} from '@angular/common';
import { EventEmitter } from '@angular/core';
import { MaterializeAction } from 'angular2-materialize';
import { YoutubePlayerModule } from 'ng2-youtube-player';
@Component({
  selector: 'app-landing',
  providers: [],
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.css']
})
export class LandingComponent implements OnInit {
  modalActions = new EventEmitter<string|MaterializeAction>();
  constructor(
    public router: Router,
    private activatedRoute: ActivatedRoute,
    private _location: Location
  ) { }

  ngOnInit() {
    // subscribe to router event
localStorage.clear();
   
  }

   player: YT.Player;
   id = 'crR9p47BylQ';
 
    savePlayer (player) {
    this.player = player;
    console.log('player instance', player)
    }
  onStateChange(event){
    console.log('player state', event.data);
  }

openModal(){
    this.modalActions.emit({action:"modal",params:['open']});   
    this.player.playVideo();
  }
  closeModal(){
    this.modalActions.emit({action:"modal",params:['close']});
    this.player.pauseVideo();   
   // this._router.navigate([`/devices`]);
  }






}



// WEBPACK FOOTER //
// C:/Users/Home/OneDrive/Documents/hotellife_web/src/app/landing/landing.component.ts